import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7f175c08"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "right_container_top d-flex a-center"
};
import roleHooks from '@/hooks/roleHooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'slideHeader',
  setup(__props) {
    const {
      setIsShowRight
    } = roleHooks();
    const close = () => {
      setIsShowRight(false);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createTextVNode(" 任务列表 "), _createElementVNode("div", {
        class: "flex-1"
      }, [_createElementVNode("div", {
        class: "closeImgWrapper cursor-p",
        onClick: close
      })])]);
    };
  }
});